(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gedeon-about-stats"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.currentScript.closest('.gedeon-about-stats');
  if (!section) return;

  const stats = section.querySelectorAll('[data-stat-index]');
  const animatedStats = new Set();

  function animateCounter(element, targetText) {
    if (animatedStats.has(element)) return;
    animatedStats.add(element);

    const numStr = targetText.replace(/[^0-9]/g, '');
    const target = parseInt(numStr, 10);
    if (isNaN(target)) {
      element.textContent = targetText;
      return;
    }

    const duration = 1500;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOutQuad = 1 - Math.pow(1 - progress, 2);
      const current = Math.floor(target * easeOutQuad);

      if (targetText.includes('%')) {
        element.textContent = current + '%';
      } else if (targetText.includes('+')) {
        element.textContent = current + '+';
      } else {
        element.textContent = current.toLocaleString('pl-PL');
      }

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.textContent = targetText;
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const valueSpan = entry.target.querySelector('[data-target]');
          if (valueSpan && !animatedStats.has(valueSpan)) {
            animateCounter(valueSpan, valueSpan.getAttribute('data-target'));
          }
        }
      });
    },
    { threshold: 0.1 }
  );

  stats.forEach(function(stat) {
    observer.observe(stat);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-announcement"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.getElementById('GedeonAnnouncement');
  const closeBtn = document.getElementById('GedeonAnnouncementClose');
  const messages = announcementBar.querySelectorAll('.gedeon-announcement__message');
  
  // Check if announcement was previously closed
  const isHidden = sessionStorage.getItem('gedeon_announcement_hidden');
  if (isHidden === 'true') {
    announcementBar.style.display = 'none';
    return;
  }
  
  // Close button handler
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      sessionStorage.setItem('gedeon_announcement_hidden', 'true');
      announcementBar.style.display = 'none';
    });
  }
  
  // Message rotation
  if (messages.length > 1) {
    let currentIndex = 0;
    messages[currentIndex].classList.add('active');
    
    setInterval(function() {
      messages[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % messages.length;
      messages[currentIndex].classList.add('active');
    }, 4000);
  } else if (messages.length === 1) {
    messages[0].classList.add('active');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-cart-freeship"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const barFill = document.querySelector('.gedeon-cart-freeship__bar-fill');
    if (barFill) {
      const percent = parseInt(barFill.getAttribute('data-percent'), 10);
      barFill.style.width = percent + '%';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.gedeon-faq');
  if (!sections.length) return;

  sections.forEach(function(section) {
    const tabButtons = section.querySelectorAll('.gedeon-faq__tab-btn');
    const faqItems = section.querySelectorAll('.gedeon-faq__item');
    const categoryHeadings = section.querySelectorAll('.gedeon-faq__category-title[data-category]');
    const questions = section.querySelectorAll('.gedeon-faq__question');

    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const activeCategory = this.getAttribute('data-category');

        tabButtons.forEach(function(b) {
          b.classList.remove('gedeon-faq__tab-btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('gedeon-faq__tab-btn--active');
        this.setAttribute('aria-selected', 'true');

        faqItems.forEach(function(item) {
          const itemCategory = item.getAttribute('data-category');
          item.style.display = activeCategory === 'all' || itemCategory === activeCategory ? '' : 'none';
        });

        categoryHeadings.forEach(function(heading) {
          const headingCat = heading.getAttribute('data-category');
          heading.style.display = activeCategory === 'all' || headingCat === activeCategory ? '' : 'none';
        });

        questions.forEach(function(q) {
          q.setAttribute('aria-expanded', 'false');
          const answerEl = document.getElementById(q.getAttribute('aria-controls'));
          if (answerEl) answerEl.setAttribute('hidden', '');
        });
      });
    });

    questions.forEach(function(question) {
      question.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answerId = this.getAttribute('aria-controls');
        const answerWrapper = document.getElementById(answerId);
        if (!answerWrapper) return;

        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          answerWrapper.setAttribute('hidden', '');
        } else {
          questions.forEach(function(q) {
            if (q !== question) {
              q.setAttribute('aria-expanded', 'false');
              const aw = document.getElementById(q.getAttribute('aria-controls'));
              if (aw) aw.setAttribute('hidden', '');
            }
          });
          this.setAttribute('aria-expanded', 'true');
          answerWrapper.removeAttribute('hidden');

          const rect = this.getBoundingClientRect();
          if (rect.top < 80) {
            window.scrollBy({ top: rect.top - 80, behavior: 'smooth' });
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-lookbook-hero"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterContainer = document.querySelector('[data-filter-container]');
  if (!filterContainer) return;

  const pills = filterContainer.querySelectorAll('[data-filter]');
  const lookbookGrid = document.querySelector('[data-lookbook-grid]');
  if (!lookbookGrid) return;

  const gridItems = lookbookGrid.querySelectorAll('[data-category]');

  pills.forEach(pill => {
    pill.addEventListener('click', function() {
      const filterValue = this.dataset.filter;

      // Update active pill
      pills.forEach(p => p.classList.remove('gedeon-lookbook-filters__pill--active'));
      this.classList.add('gedeon-lookbook-filters__pill--active');

      // Filter grid items
      gridItems.forEach(item => {
        const itemCategory = item.dataset.category;
        const isMatch = filterValue === '*' || itemCategory === filterValue;

        if (isMatch) {
          item.style.display = '';
          setTimeout(() => item.classList.add('gedeon-lookbook-grid__item--visible'), 10);
        } else {
          item.classList.remove('gedeon-lookbook-grid__item--visible');
          setTimeout(() => item.style.display = 'none', 250);
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-returns-steps"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.gedeon-returns-steps');
  if (!sections.length) return;

  sections.forEach(function(section) {
    const steps = section.querySelectorAll('.gedeon-returns-steps__step');
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    steps.forEach(function(step) {
      step.style.opacity = '0';
      observer.observe(step);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-shipping-payment"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.gedeon-shipping-payment').forEach(function(section) {
    section.querySelectorAll('.gedeon-shipping-payment__question').forEach(function(button) {
      button.addEventListener('click', function() {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var answer = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (answer) {
          if (expanded) {
            answer.setAttribute('hidden', '');
          } else {
            answer.removeAttribute('hidden');
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-size-guide-tables"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabButtons = document.querySelectorAll(".gedeon-size-tables__tab-btn");
  const tabContents = document.querySelectorAll(".gedeon-size-tables__tab-content");

  tabButtons.forEach(button => {
    button.addEventListener("click", function() {
      const tabId = this.getAttribute("data-tab");
      
      // Remove active state from all buttons and contents
      tabButtons.forEach(btn => btn.classList.remove("gedeon-size-tables__tab-btn--active"));
      tabContents.forEach(content => content.classList.remove("gedeon-size-tables__tab-content--active"));
      
      // Add active state to clicked button and corresponding content
      this.classList.add("gedeon-size-tables__tab-btn--active");
      document.getElementById("tab-" + tabId).classList.add("gedeon-size-tables__tab-content--active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gedeon-size-guide-visual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const frameSelector = document.getElementById("frame-selector");
  const frameDisplay = document.getElementById("frame-display");
  const frameLabel = document.getElementById("frame-label");
  const styleButtons = document.querySelectorAll(".gedeon-size-visual__style-btn");
  let currentStyle = "natural";

  function updateFrame() {
    const selectedOption = frameSelector.options[frameSelector.selectedIndex];
    const width = parseFloat(selectedOption.getAttribute("data-width"));
    const height = parseFloat(selectedOption.getAttribute("data-height"));
    const text = selectedOption.text;

    // Update frame dimensions (scale for preview)
    const scale = Math.min(200 / width, 250 / height);
    frameDisplay.style.width = (width * scale) + "px";
    frameDisplay.style.height = (height * scale) + "px";
    frameLabel.textContent = text;
  }

  styleButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      styleButtons.forEach(b => b.classList.remove("gedeon-size-visual__style-btn--active"));
      this.classList.add("gedeon-size-visual__style-btn--active");
      
      const style = this.getAttribute("data-style");
      frameDisplay.classList.remove("gedeon-size-visual__frame--black", "gedeon-size-visual__frame--white");
      
      if (style === "black") {
        frameDisplay.classList.add("gedeon-size-visual__frame--black");
      } else if (style === "white") {
        frameDisplay.classList.add("gedeon-size-visual__frame--white");
      }
    });
  });

  frameSelector.addEventListener("change", updateFrame);
  updateFrame();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
